import { groupTypeLabel } from './sp-group-type.exports';

export class Controller {

    $onChanges() {
        this.tooltipKey = groupTypeLabel(this.groupType);

        this.iconClass = ({
            AD: 'text-primary fa-solid fa-audio-description',
            AZURE_AD: 'text-primary fa-solid fa-diamond',
            AD_DOMAIN: 'text-primary fa-solid fa-audio-description',
            AD_GROUP: 'text-primary fa fa-lg fa-users',
            AZURE_GROUP: 'text-primary fa fa-lg fa-users',
            AD_OU: 'text-primary fa fa-lg fa-sitemap',
            APPLICATION: 'text-primary fa fa-lg fa-list-alt',
            CUSTOM: 'text-primary fa fa-lg fa-wrench',
            DOMAIN: 'text-primary fa fa-lg fa-database',
            EVERYONE: 'text-primary fa fa-lg fa-users',
            EXTERNAL_EMAILS: 'text-primary fa fa-lg fa-envelope',
            PHONE_NUMBERS: 'text-primary fa fa-lg fa-phone',
            UNKNOWN: 'text-primary fa fa-lg fa-ban',
        })[this.groupType];
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-group-type/sp-group-type.controller.js